import Typography from '@material-ui/core/Typography';
import EllipsisWithTooltip from '../Formater/EllipsisWithTooltip';
import React from 'react';

const TowLine = ({main, sub, subVariant}) => (
    <React.Fragment>
        {main}
        {sub && (
            <Typography variant={subVariant || 'subtitle2'}>
                <EllipsisWithTooltip>
                    {sub}
                </EllipsisWithTooltip>
            </Typography>
        )}
    </React.Fragment>
);

export default TowLine;
